import ForgotPassword from './ForgotPassword';
import ChangePassword from './ChangePassword';

export { ChangePassword, ForgotPassword };
